import { ReactionLoveIcon } from "@icons/ReactionLoveIcon";
import { ReactionLikeIcon } from "@icons/ReactionLikeIcon";
import { ReactionLaughIcon } from "@icons/ReactionLaughIcon";
import { ReactionHushedIcon } from "@icons/ReactionHushedIcon";
import { ReactionAngryIcon } from "@icons/ReactionAngryIcon";
import { ReactionSadIcon } from "@icons/ReactionSadIcon";
import { ReactionDislikeIcon } from "@icons/ReactionDislikeIcon";
import { SxProps } from "@mui/material";
import React from "react";
import { ReactionsNamesEnum } from "../../../Types/Reactions/ReactionsNamesEnum";

const iconsMap: Record<ReactionsNamesEnum, JSX.Element> = {
    love: <ReactionLoveIcon />,
    like: <ReactionLikeIcon />,
    laugh: <ReactionLaughIcon />,
    hushed: <ReactionHushedIcon />,
    angry: <ReactionAngryIcon />,
    sad: <ReactionSadIcon />,
    dislike: <ReactionDislikeIcon />,
};
export function GetReactionIcon({
    reactionName,
    sx = {},
}: {
    reactionName: string;
    sx?: SxProps;
}) {
    return iconsMap[reactionName as ReactionsNamesEnum]
        ? React.cloneElement(iconsMap[reactionName as ReactionsNamesEnum], {
              ...sx,
          })
        : null;
}
